import sx from 'utils/createSx';

export const DIALOG_PAPER_SLOT = {
  sx: {
    maxWidth: '100%',
    overflow: 'hidden',
  },
};

export default sx({
  dialogTitle: { pr: 1 },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
  },
  titleTypography: { fontWeight: 600 },
  dialogContent: {
    pt: 2,
    overflowX: 'hidden',
    overflowY: 'auto',
    maxWidth: '100%',
  },
  formStack: { width: '100%' },
  photosOverline: { display: 'block', mb: 1 },
  imageList: {
    width: '100%',
    maxWidth: '100%',
    m: 0,
    overflow: 'hidden',
  },
  imageListItem: { borderRadius: 1, overflow: 'hidden' },
  dialogActions: { px: 3, py: 2, flexWrap: 'wrap', gap: 1 },
});
